// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"862":"21f4ab05","894":"21f4ab05","1078":"1e6aefc2","3753":"1e6aefc2"}[chunkId] + ".chunk.css";
};